// removed by extract-text-webpack-plugin
module.exports = {"cls1":"_1AGwu","cls3":"_1ZSwa","cls2":"_25ffb","cls4":"_3Et3F","cls5":"_3exvR","cls7":"_3mgsO","cls8":"_3nWSy","cls9":"_2EWPQ","cls6":"_3b0Jq"};